export const LOAD_PARAMETROS_SUCCESS = 'LOAD_PARAMETROS_SUCCESS';

export interface IParametro {
    id: number
    nombre: string
    descripcion: string
    valor: string
}

interface ILoadParametros {
    type: typeof LOAD_PARAMETROS_SUCCESS
    parametros: IParametro[]
}

export type ParametroActionTypes = ILoadParametros
